import { wellDirectoryServiceAgent } from 'src/api/well-directory-service-agent';

export class WellApi {
  async getWells(body: unknown, params: Partial<Record<string, string | number>>): Promise<object> {
    const wells = await wellDirectoryServiceAgent.post<object>('wells/select', body, {
      params,
    });

    return wells.data;
  }
}
